svg{width:100%;height:100%}img{vertical-align:top;-webkit-user-select:none;user-select:none}
/*# sourceMappingURL=image-renderer.component.css.map */
